import React, { useEffect, useState, useCallback } from "react";
import apiService from "../../services/apiService";

/** Sidebar panel listing saved analysis runs for the project; click to reload, or delete. */
function AnalysisHistory({ projectId, refreshKey, onSelectRun }) {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadHistory = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const { data } = await apiService.get(`/analysis/history/${projectId}`);
      setRuns(data.runs || []);
    } catch (err) {
      console.error("Failed to load analysis history:", err);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    loadHistory();
  }, [loadHistory, refreshKey]);

  const handleDelete = async (e, runId) => {
    e.stopPropagation();
    try {
      await apiService.delete(`/analysis/run/${projectId}/${runId}`);
      setRuns((prev) => prev.filter((r) => r.id !== runId));
    } catch (err) {
      console.error("Failed to delete run:", err);
    }
  };

  return (
    <div className="analysis-history-panel">
      <h4>Run History</h4>
      {loading && <p className="analysis-muted">Loading...</p>}
      {!loading && runs.length === 0 && <p className="analysis-muted">No saved runs yet.</p>}
      <ul className="analysis-history-list">
        {runs.map((run) => (
          <li key={run.id} className="analysis-history-item" onClick={() => onSelectRun(run)}>
            <div className="analysis-history-item-main">
              <span className="analysis-history-label">{run.label || run.analysisType}</span>
              <span className="analysis-history-date">{run.createdAt ? new Date(run.createdAt).toLocaleString() : ""}</span>
            </div>
            <button className="analysis-history-delete" onClick={(e) => handleDelete(e, run.id)} title="Delete run">
              &times;
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AnalysisHistory;
